var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6666 43.75V39.5833C41.6666 37.3732 40.7886 35.2536 39.2258 33.6908C37.663 32.128 35.5434 31.25 33.3333 31.25H16.6666C14.4564 31.25 12.3368 32.128 10.774 33.6908C9.21123 35.2536 8.33325 37.3732 8.33325 39.5833V43.75",
    stroke: "white",
    strokeWidth: 4.26337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 22.9167C29.6025 22.9167 33.3334 19.1857 33.3334 14.5833C33.3334 9.98096 29.6025 6.25 25.0001 6.25C20.3977 6.25 16.6667 9.98096 16.6667 14.5833C16.6667 19.1857 20.3977 22.9167 25.0001 22.9167Z",
    stroke: "white",
    strokeWidth: 4.26337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0637f0d44b91c8c7f3171f318eb3a3f6.svg";
export { ForwardRef as ReactComponent };